export const LABEL_CREATE_RESET = 'LABEL_CREATE_RESET'
export const LABEL_CREATE_SET_CREATED = 'LABEL_CREATE_SET_CREATED'
export const LABEL_CREATE_SET_ERROR = 'LABEL_CREATE_SET_ERROR'
export const LABEL_CREATE_SET_VIOLATIONS = 'LABEL_CREATE_SET_VIOLATIONS'
export const LABEL_CREATE_TOGGLE_LOADING = 'LABEL_CREATE_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/label/create/mutation_types.js